module.exports = __webpack_public_path__ + "img/img_intro_form.80af64a4.png";